import Head from "next/head";
import BigCopy from "~/components/BigCopy";
import Block, { BlockContent, BlockGrid, BlockTopSpacer } from "~/components/Block";
import BreadCrumbs from "~/components/BreadCrumbs";
import Divider from "~/components/Divider";
import Spacer from "~/components/Spacer";
import { prismic } from "~/external/v2/prismic";
import Error from "~/views/Error";

function Presskit({
  title,
  date,
  link,
}: {
  title: string;
  date: string;
  link: string;
}) {
  const formattedDate = new Intl.DateTimeFormat("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  }).format(new Date(date));

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none", color: "inherit" }}
    >
      <div>
        <h3 style={{ margin: 0 }}>{title}</h3>
        <p style={{ margin: 0, color: "gray" }}>{formattedDate}</p>
      </div>
    </a>
  );
}

function PressKitsPage(props: PressKitsPageProps) {
  if (props.error) return <Error {...props.error} />;

  const { press_kits } = props;
  const breadcrumbs = [["AIAIAI", "/press"]];

  return (
    <>
      <Head>
        <title>Press Resources | AIAIAI</title>
        <meta
          name="description"
          //   content={`All ${storyType.plural.toLowerCase()}.`}
          key="meta-d"
        />
        {/* <meta key="meta-r" name="robots" content="index, follow" /> */}
      </Head>
      <Block>
        <BlockTopSpacer />
        <BlockContent>
          <BreadCrumbs linkAll={false} breadcrumbs={breadcrumbs} />
          <Divider opacity={0.26} />
          <BigCopy fontWeight={800}>
            <h1 style={{ margin: 0 }}>Press Resources</h1>
          </BigCopy>
          <h2>Contact</h2>
          <p>press@aiaiai.audio</p>
          <Spacer></Spacer>
          <p>
            AIAIAI Audio
            <br />
            Amalievej 20
            <br />
            1875 Frederiksberg C<br />
            Copenhagen, Denmark
          </p>
        </BlockContent>

        <Spacer size={3}></Spacer>

        <BlockContent>
          <h2>Press Kits</h2>
          <BlockGrid columnsOnMobile={1} cols={1} style={{ gridGap: "2rem 1.25rem" }}>
            {press_kits.map((press_kit, i) => (
              <Presskit
                title={press_kit.content.title}
                date={press_kit.content.date}
                link={press_kit.content.link?.url}
              />
            ))}
          </BlockGrid>
        </BlockContent>

        <Spacer size={5}></Spacer>
      </Block>
    </>
  );
}

export const getServerSideProps = async ({ query, res }) => {
  const documents = await prismic.pressKit.get.all();

  if (!documents) {
    res.statusCode = 404;
    return {
      props: {
        error: {
          statusCode: 404,
          message: "Document not found",
        },
      },
    };
  }

  return {
    props: {
      press_kits: documents,
    },
  };
};

export default PressKitsPage;
